import "src/decidim/forms/forms"

// CSS
import "stylesheets/decidim/forms/forms.scss"
import "stylesheets/decidim/forms/questionnaire-answers-pdf.scss"

// Images
require.context("../images", true)
